import 'core-js/modules/es.object.assign.js';
import { Button } from '../../components/button/button.overrides.js';

const makeComponents = theme => Object.assign(Button(theme));

export { makeComponents };
